import * as React from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { useState } from "react";
import AddPelangganDialog from "./AddPelangganDialog";

import Button from "@mui/material/Button";

// Transition for the slide animation
const Transition = React.forwardRef(function Transition(
  props, // No type annotations here
  ref
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FieldPelangganDialog = ({
  dataPelanggan,
  pageSize,
  openPelanggan,
  handleClosePelanggan,
  onSelect,
}) => {
  const [searchValue, setSearchValue] = useState("");

  const colors = ["#f8bbd0", "#b2ebf2", "#c5e1a5", "#ffe082", "#d1c4e9"];

  const [openAddPelanggan, setOpenAddPelanggan] = useState(false);

  // Filter berdasarkan nama atau nomor HP
  const filteredPelanggan = dataPelanggan.filter((pelanggan) =>
    pelanggan.name.toLowerCase().includes(searchValue.toLowerCase()) ||
    pelanggan.mobile.includes(searchValue)
  );
 
  const isSearching = searchValue.trim() !== "";
const displayedPelanggan = isSearching
  ? filteredPelanggan
  : filteredPelanggan.slice(0, pageSize);

  const formatHiddenPhone = (mobile) => {
    if (mobile.length < 7) return mobile; 
    return (
      mobile.substring(0, 4) + 
      "*".repeat(mobile.length - 7) + 
      mobile.substring(mobile.length - 3) 
    );
  };

  const handleOpenAddPelanggan = () => {
    setOpenAddPelanggan(true);
  };

  const handleCloseAddPelanggan = () => {
    setOpenAddPelanggan(false);
  };

  return (
    <Dialog
      fullScreen
      open={openPelanggan}
      onClose={handleClosePelanggan}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <Typography
            sx={{ ml: 2, flex: 1, textAlign: "center" }}
            variant="h6"
            component="div"
          >
            Pilih Pelanggan
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleClosePelanggan}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2, borderRadius: 3, bgcolor: "#f5f5f5", mb: 2 }}>
        <TextField
          fullWidth
          size="small"
          placeholder="Cari Pelanggan"
          variant="outlined"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{
            bgcolor: "#fff",
            borderRadius: 2,
            mb: 2,
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
            },
          }}
        />

        <Typography
          variant="body2"
          fontWeight="bold"
          color="text.primary"
          gutterBottom
          sx={{ mb: 2 }}
        >
          Daftar Pelanggan
        </Typography>

        {filteredPelanggan.length === 0 ? (
          <Box
            sx={{
              p: 2,
              borderRadius: 2,
              bgcolor: "#f5f5f5",
              boxShadow: 0,
              mb: 1,
              textAlign: "center",
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Data tidak ditemukan
            </Typography>
          </Box>
        ) : (
          displayedPelanggan.map((pelanggan, index) => (
            <Box
              key={index}
              onClick={() => onSelect(pelanggan)}
              sx={{
                p: 2,
                borderRadius: 2,
                bgcolor: "#ffffff",
                boxShadow: 1,
                mb: 1,
                cursor: "pointer",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    backgroundColor: colors[index % colors.length],
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 2,
                  }}
                >
                  <Typography variant="subtitle2" fontWeight="bold">
                    {(
                      pelanggan.name.charAt(0) +
                      pelanggan.name.charAt(pelanggan.name.length - 1)
                    ).toUpperCase()}
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    variant="body2"
                    color="text.primary"
                    fontWeight="bold"
                  >
                    {pelanggan.name}
                  </Typography>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    display="block"
                  >
                    {formatHiddenPhone(pelanggan.mobile)}
                  </Typography>
                </Box>
              </Box>
            </Box>
          ))
        )}

        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#ffffff",
            boxShadow: 1,
            mb: 1,
          }}
        >
          <Button
            variant="contained"
            fullWidth
            onClick={handleOpenAddPelanggan}
            sx={{
              textTransform: "none",
              bgcolor: "#424242",
              borderRadius: 5,
              ":hover": {
                bgcolor: "#08306b",
              },
            }}
          >
            Tambah Pelanggan
          </Button>
        </Box>
      </Box>

      <AddPelangganDialog
       
        open={openAddPelanggan}
        handleClose={handleCloseAddPelanggan}
      />
    </Dialog>
  );
};

export default FieldPelangganDialog;
